var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVacuumCleaner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD1D9"
    },
    d: "M449.294,9.375c-12.5-12.5-32.75-12.5-45.25,0L87.265,326.154c-12.5,12.5-12.5,32.766,0,45.25 c12.484,12.5,32.75,12.5,45.25,0l316.779-316.78C461.794,42.124,461.794,21.875,449.294,9.375z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M64,501.324c0,5.891-4.766,10.672-10.656,10.672H10.672c-5.891,0-10.671-4.781-10.671-10.672V394.67 c0-5.891,4.781-10.672,10.671-10.672h42.672c5.891,0,10.656,4.781,10.656,10.672V501.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.999,501.324c0,5.891-4.766,10.672-10.656,10.672h-42.672c-5.891,0-10.671-4.781-10.671-10.672 V394.67c0-5.891,4.781-10.672,10.671-10.672h42.672c5.891,0,10.656,4.781,10.656,10.672V501.324z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EB"
    },
    d: "M287.999,501.324c0,5.891-4.766,10.672-10.656,10.672H42.672c-5.891,0-10.672-4.781-10.672-10.672 c0,0-64-351.997,128-351.997C351.996,149.328,287.999,501.324,287.999,501.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M159.077,309.326c-29.406,0-53.328-23.922-53.328-53.328s23.922-53.328,53.328-53.328 s53.343,23.922,53.343,53.328S188.482,309.326,159.077,309.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M159.077,191.999c-35.344,0-64,28.656-64,64c0,35.343,28.656,64,64,64c35.359,0,64-28.656,64-64 C223.077,220.655,194.437,191.999,159.077,191.999z M159.077,298.67c-23.516,0-42.656-19.141-42.656-42.671 c0-23.531,19.141-42.672,42.656-42.672c23.531,0,42.671,19.141,42.671,42.672C201.749,279.529,182.607,298.67,159.077,298.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M266.671,394.67c0,5.89-4.781,10.655-10.671,10.655c-5.891,0-10.656-4.766-10.656-10.655 c0-5.891,4.766-10.672,10.656-10.672C261.889,383.998,266.671,388.779,266.671,394.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M234.671,394.67c0,5.89-4.781,10.655-10.672,10.655s-10.656-4.766-10.656-10.655 c0-5.891,4.766-10.672,10.656-10.672S234.671,388.779,234.671,394.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M95.999,458.669c-5.891,0-10.656,4.766-10.656,10.656v42.499h21.328v-42.499 C106.671,463.435,101.89,458.669,95.999,458.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M138.671,458.669c-5.891,0-10.672,4.766-10.672,10.656v42.499h21.344v-42.499 C149.342,463.435,144.562,458.669,138.671,458.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M181.342,458.669c-5.891,0-10.671,4.766-10.671,10.656v42.499h21.327v-42.499 C191.999,463.435,187.232,458.669,181.342,458.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M223.999,458.669c-5.891,0-10.656,4.766-10.656,10.656v42.499h21.328v-42.499 C234.671,463.435,229.89,458.669,223.999,458.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M22.266,351.998h275.468c-0.281-7.062-0.703-14.188-1.281-21.328H23.547 C22.984,337.81,22.562,344.936,22.266,351.998z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M159.999,106.671c-17.672,0-32,14.328-32,32v117.327c0,17.671,14.328,32,32,32 c17.671,0,32-14.328,32-32V138.671C191.999,120.999,177.671,106.671,159.999,106.671z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 281.259,
    y: 134.762,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 194.5804 -178.9116)",
    style: {
      fill: "#AAB2BC"
    },
    width: 63.992,
    height: 21.324
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.093,
    y: 164.926,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 207.0738 -148.746)",
    style: {
      fill: "#AAB2BC"
    },
    width: 63.991,
    height: 21.323
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAB2BC"
    },
    points: "359.496,53.906 344.421,68.999 389.669,114.249 404.763,99.171  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAB2BC"
    },
    points: "314.249,99.171 359.496,144.421 374.591,129.343 329.327,84.078  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 127.999,
    y: 223.998,
    style: {
      fill: "#CCD1D9"
    },
    width: 64,
    height: 21.328
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.999,
    y: 181.328,
    style: {
      fill: "#CCD1D9"
    },
    width: 64,
    height: 21.343
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.999,
    y: 138.668,
    style: {
      fill: "#CCD1D9"
    },
    width: 64,
    height: 21.328
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M426.669,0c-17.672,0-32,14.328-32,32v447.998c0,17.671,14.328,31.999,32,31.999s32-14.328,32-31.999 V31.999C458.669,14.328,444.341,0,426.669,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.669,
    y: 181.328,
    style: {
      fill: "#AC92EB"
    },
    width: 64,
    height: 85.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M447.996,223.998c0,5.891,4.781,10.672,10.672,10.672v-21.344 C452.777,213.327,447.996,218.108,447.996,223.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADC"
    },
    d: "M405.341,223.998c0-5.891-4.781-10.672-10.672-10.672v21.344 C400.56,234.67,405.341,229.889,405.341,223.998z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#656D78"
    },
    points: "458.669,426.669 458.669,405.325 394.669,405.325 394.669,426.669 341.342,447.997  341.342,511.996 511.996,511.996 511.996,447.997 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.669,458.669h-64c-5.891,0-10.672,4.766-10.672,10.656s4.781,10.672,10.672,10.672h64 c5.891,0,10.672-4.781,10.672-10.672S464.56,458.669,458.669,458.669z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacuumCleaner);
export default __webpack_public_path__ + "static/media/vacuum-cleaner.592774b2ee4ee9d90af715a9605cd506.svg";
export { ForwardRef as ReactComponent };